/** The ToggleButtonBarEvent is dispatched when the user selects a non selected ToggleButton in the ToggleButtonBar. */
export default class ToggleButtonBarEvent extends Event {
	/**
	 * The static SELECTED_INDEX_CHANGED property is used by the listeners, so we dont't get typo bugs.
	 *
	 * Example: addEventListener(ToggleButtonBarEvent.SELECTED_INDEX_CHANGED, (event: ToggleButtonBarEvent<string>) => {});
	 */
	public static SELECTED_INDEX_CHANGED = 'ToggleButtonBarEvent.selectedIndexChanged';
	/** The selectedIndex property is the index position of the ToggleButton currently selected. */
	public selectedIndex: number;

	public constructor(selectedIndex = 0) {
		super('ToggleButtonBarEvent.selectedIndexChanged', { bubbles: true });
		assertIsNonNegativeInteger(selectedIndex);
		this.selectedIndex = selectedIndex;
	}
}

function assertIsNonNegativeInteger(value: unknown): asserts value is number {
	if (typeof value === 'number' && value >= 0 && Number.isInteger(value)) {
		return;
	}
	throw new TypeError(`[${String(value)}] is invalid, must be a non negative integer`);
}
